import { FC, useId } from "react";

interface ArkLogoMarkProps {
  className?: string;
}

const ARK_ARC = "M5 44 A64 64 0 0 1 44 5";

export const ArkLogoMark: FC<ArkLogoMarkProps> = ({ className }) => {
  const clipId = useId();

  return (
    <svg viewBox="0 0 48 48" className={className} role="img" aria-label="Ark">
      <clipPath id={clipId}>
        <rect x="0.5" y="0.5" width="47" height="47" rx="6" />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <rect x="0.5" y="0.5" width="47" height="47" rx="6" fill="#f9b916" />
        <path
          className="ark-logo-arc"
          d={ARK_ARC}
          pathLength={100}
          fill="none"
          stroke="#ffffff"
          strokeWidth={7}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
